import { render } from "./DeckBuilderComponent.vue?vue&type=template&id=7f631abb&scoped=true"
import script from "./DeckBuilderComponent.vue?vue&type=script&lang=js"
export * from "./DeckBuilderComponent.vue?vue&type=script&lang=js"

import "./DeckBuilderComponent.vue?vue&type=style&index=0&id=7f631abb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f631abb"]])

export default __exports__